export const formatCurrency = (value) => {
    return value ? Math.floor(value)?.toLocaleString('ru-RU') : '0';
};